import { render, staticRenderFns } from "./detailLog.vue?vue&type=template&id=680a4554"
import script from "./detailLog.vue?vue&type=script&lang=js"
export * from "./detailLog.vue?vue&type=script&lang=js"
import style0 from "./detailLog.vue?vue&type=style&index=0&id=680a4554&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680a4554')) {
      api.createRecord('680a4554', component.options)
    } else {
      api.reload('680a4554', component.options)
    }
    module.hot.accept("./detailLog.vue?vue&type=template&id=680a4554", function () {
      api.rerender('680a4554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/quotationManagement/cmp/detailLog.vue"
export default component.exports